
import { defineComponent, PropType } from 'vue'
import { mapActions } from 'vuex'
import { OrgUsersActions } from '~/store/control-panel/users'
import { EnterpriseGroup, EnterpriseUser } from '~/types/types'
import MutationFailedError from '~/utils/mutationFailedError'

export default defineComponent({
  name: 'RemoveUserFromGroupButton',
  props: {
    orgUser: {
      type: Object as PropType<EnterpriseUser>,
      required: true
    },
    group: {
      type: Object as PropType<EnterpriseGroup>,
      required: true
    }
  },
  data() {
    return {
      showRemoveUserFromGroupConfirm: false,
      isRemovingUser: false
    }
  },
  methods: {
    ...mapActions('control-panel/users', {
      removeUserFromGroup: OrgUsersActions.REMOVE_USER_FROM_GROUP
    }),
    showConfirm() {
      this.showRemoveUserFromGroupConfirm = true
    },
    async removeUser(groupId: string, userId: string, close: () => void) {
      this.isRemovingUser = true
      try {
        const response = await this.removeUserFromGroup({ groupId, userId })
        if (!response)
          throw new MutationFailedError('An error occured while removing user, please try again.')
        this.$toast.success('User removed from group succesfully.')
      } catch (e) {
        this.$toast.danger((e as Error).message)
      } finally {
        this.$emit('refetch')
        if (close) close()
        this.isRemovingUser = false
      }
    }
  }
})
